export type ErrorReportContext = {
  area?: string
  action?: string
  route?: string
  orgId?: string
  userId?: string
  severity?: 'info' | 'warning' | 'error' | 'fatal'
  tags?: Record<string, string>
  extra?: Record<string, unknown>
}

/**
 * Client-safe error report.
 *
 * Client-side Sentry is intentionally disabled to keep the ~417KB SDK out of the
 * browser bundle, so this no longer captures to Sentry or returns an event id —
 * the error boundary still renders its fallback UI. Server-side reporting (which
 * does capture to Sentry and returns an event id) lives in `report.server.ts`
 * and must only be imported from server code.
 */
export function reportClientError(error: unknown, context: ErrorReportContext = {}): string | null {
  // Client Sentry is disabled, so nothing is captured client-side. Args are kept
  // for call-site compatibility with the former Sentry-backed signature.
  void error
  void context
  return null
}
